"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAccountNumber = void 0;
var formatAccountNumber = function (value) {
    return value
        .replace(/[^\dA-Z]/g, '')
        .replace(/(.{3})/g, '$1 ')
        .trim();
};
exports.formatAccountNumber = formatAccountNumber;
//# sourceMappingURL=formatAccountNumber.js.map